import { render, staticRenderFns } from "./Goldsetting.vue?vue&type=template&id=00992572&scoped=true"
import script from "./Goldsetting.vue?vue&type=script&lang=js"
export * from "./Goldsetting.vue?vue&type=script&lang=js"
import style0 from "./Goldsetting.vue?vue&type=style&index=0&id=00992572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00992572",
  null
  
)

export default component.exports